import { Component, OnInit } from '@angular/core';

import { Request } from '../request/shared/request.model';
import { Response } from '../response/shared/response.model';
import { ResponseService } from './shared/response.service';
import { Observable } from 'rxjs';
import { RequestService } from '../request/shared/request.service';
import { ActivatedRoute } from '@angular/router';
import { faUndo } from '@fortawesome/free-solid-svg-icons/faUndo';

@Component({
  selector: 'app-response',
  templateUrl: './response.component.html',
  styleUrls: ['./response.component.css']
})
export class ResponseComponent implements OnInit {
  request$: Observable<Request>;
  response$: Observable<Response>;
  clientToken: string;
  faUndo = faUndo;

  constructor(
    private readonly requestService: RequestService,
    private readonly responseService: ResponseService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.clientToken = this.route.snapshot.paramMap.get('clientToken');
    this.request$ = this.requestService.request$;
    this.response$ = this.responseService.response$;
  }
}
